import { Box, Text } from "rebass/styled-components";
import styled from "styled-components";

interface LoadMoreCTAProps {
  onClick: () => void;
  visible: boolean;
}

export const LoadMoreCTA = ({ onClick, visible }: LoadMoreCTAProps) => (
  <CTAButton onClick={onClick} $visible={visible}>
    <Text fontSize="11px" fontWeight={700}>
      Load more clips →
    </Text>
  </CTAButton>
);

const CTAButton = styled(Box)<{ $visible: boolean }>`
  cursor: pointer;
  background: #3273fa;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
  transition:
    opacity 150ms ease,
    background 120ms ease;
  &:hover {
    background: #4683ff;
  }
`;
